





























import { Component, Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import VueEvent from "@/app/core/decorator/VueEvent";
import { Prop, Watch } from "vue-property-decorator";
import { CardDeckBig, CardMeta } from "@/@types/gameObject";
import CardComponent from "@/app/basic/card/CardComponent.vue";
import { StoreUseData } from "@/@types/store";
import { createSize } from "@/app/core/utility/CoordinateUtility";
import CssManager from "@/app/core/css/CssManager";
import { getCssPxNum } from "@/app/core/css/Css";
import { Size } from "address";

export type DeckInfo = {
  cardDeckBig: StoreUseData<CardDeckBig>;
  cardMetaList: StoreUseData<CardMeta>[];
};

@Component({
  components: { CardComponent }
})
export default class CardDeckSetComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Object, required: true })
  private deck!: DeckInfo;

  @Prop({ type: Boolean, required: true })
  private isSelected!: boolean;

  @Prop({ type: Number, default: 16 })
  private size!: number;

  @VueEvent
  private get cardSize(): Size {
    const fontSize = getCssPxNum("font-size", this.elm);
    return createSize(
      (this.size * fontSize * 4) / 10,
      (this.size * fontSize * 6) / 10
    );
  }

  private get elm(): HTMLDivElement {
    return this.$refs.elm as HTMLDivElement;
  }

  @VueEvent
  private getSampleList(list: StoreUseData<CardMeta>[]) {
    return list.slice(0, 3);
  }
}
